import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import { AppUtils } from "../../../utils/appUtils";
import RegisterFilter from "../../../components/register-filter/RegisterFilter";
import PublicRepresentativeList from "../public-representative/helpers/PublicRepresentativeList";

const SearchPublicRepresentative = () => {
  const dispatch = useDispatch();
  const printComponentRef = useRef();

  const [tableData, setTableData] = useState([]);
  const [size, setSize] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const { gender, phoneNumber, searchText, pageNumber, rowsPerPage, formerPublicRepresentative, publicRepresentativePost } = useSelector((state) => state.searchFilter);

  useEffect(() => {
    getPublicRepresentatives();
  }, [pageNumber, rowsPerPage, searchText, gender, phoneNumber, formerPublicRepresentative, publicRepresentativePost]);

  const getPublicRepresentatives = () => {
    setIsLoading(true);

    let url = `${API_URL.publicRepresentative}?pageNumber=${pageNumber}&rowSize=${rowsPerPage}`;

    if (searchText) url += `&searchParam=${searchText}`;
    if (gender) url += `&gender=${gender}`;
    if (phoneNumber) url += `&phoneNumber=${phoneNumber}`;
    if (publicRepresentativePost) url += `&post=${publicRepresentativePost}`;
    if (formerPublicRepresentative) {
      url += `&formerPublicRepresentative=${formerPublicRepresentative}`;
    }

    PIS.get(url)
      .then((response) => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data?.objectList || []);
          setSize(jsondata.data.size || 0);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
        setIsLoading(false);
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
        setIsLoading(false);
      });
  };

  const fieldVisibility = {
    gender: true,
    phoneNumber: true,
    formerPublicRepresentative: true,
    publicRepresentativePost: true
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        borderBottom={1}
        mb={3}
        pb={1}
      >
        <Typography variant="h5">जन प्रतिनिधि खोज्नुहोस</Typography>
      </Box>

      <RegisterFilter
        fieldVisibility={fieldVisibility}
        showSearchField={true}
        searchFieldLabel="नाम बाट खोज्नुहोस्"
      />
      <Box ref={printComponentRef}>
        <PublicRepresentativeList
          isLoading={isLoading}
          size={size}
          rowsPerPage={rowsPerPage}
          getTableData={getPublicRepresentatives}
          tableData={tableData}
          showActionColumn={false}
          pageSize={pageNumber}
        />
      </Box>
    </Box>
  );
}

export default SearchPublicRepresentative;
